import { gql } from "@apollo/client";

export const CHECK_VISITS_EXIST = gql`
  query checkVisitsExist($Id: ID) {
    Account(Id: $Id) {
      Id
      Visits(Take: 1) {
        Id
      }
    }
  }
`;
